import { post, uploadImg } from './utils';

const smsCode = (query) => {
  return post('PublicApi/smsCode', query);
};

const forgetPwd = (query) => {
  return post('PublicApi/forgetPwd', query);
};

const register = (query) => {
  return post('PublicApi/registerPc', query);
};

const login = (query) => {
  return post('PublicApi/login', query);
};

const index = (query) => {
  return post('Indexpc/index', query);
};

const getCategory = (query) => {
  return post('Index/getCategory', query);
};

const getThreeCat = (query) => {
  return post('Index/getThreeCat', query);
};

const Order = (query) => {
  return post('Order/index', query);
};

const info = (query) => {
  return post('Order/info', query);
};

const orderCopy = (query) => {
  return post('Order/orderCopy', query);
};

const setStatus = (query) => {
  return post('Order/setStatus', query);
};

const ItemList = (query) => {
  return post('Item/ItemList', query);
};

const add = (query) => {
  return post('Cart/add', query);
};

const doCount = (query) => {
  return post('Cart/doCount', query);
};

const getAttribute = (query) => {
  return post('Index/getAttribute', query);
};

const getCatList = (query) => {
  return post('Cart/index', query);
};

const remove = (query) => {
  return post('Cart/remove', query);
};

const emptyCart = (query) => {
  return post('Cart/emptyCart', query);
};

const update = (query) => {
  return post('Cart/update', query);
};

const addOrder = (query) => {
  return post('Cart/addOrder', query);
};

const editUserInfo = (query) => {
  return post('User/editUserInfo', query);
};

const getUserInfo = (query) => {
  return post('User/getUserInfo', query);
};

const changePwd = (query) => {
  return post('PublicApi/changePwd', query);
};

const noticeList = (query) => {
  return post('User/noticeListPc', query);
};

const doc = (query) => {
  return post('PublicApi/docPc', query);
};

const graffiti = (query) => {
  return uploadImg('Item/graffiti', query);
};

const noticeInfo = (query) => {
  return post('User/noticeInfo', query);
};

const ItemNewList = (query) => {
  return post('item/ItemNewList', query);
};
const orderItemPic = (query) => {
  return uploadImg('Order/orderItemPic', query);
};
const newItem = (query) => {
  return post('Item/newItem', query);
};
const editPassword = (query) => {
  return post('User/editPassword', query);
};
export default {
  smsCode: smsCode, //发送验证码
  forgetPwd: forgetPwd, //找回密码
  register: register, //注册
  login: login, //登录
  index: index, //首页数据
  getThreeCat: getThreeCat, //获取一级分类
  Order: Order, // 获取订单列表
  info: info, // 订单详情
  orderCopy: orderCopy, //复制订单
  setStatus: setStatus, //更改订单状态
  getCategory: getCategory, //获取二级
  getThreeCat: getThreeCat, //获取三级分类
  ItemList: ItemList, //商品列表
  add: add, //加入购物车
  doCount: doCount, //购物车统计
  getAttribute: getAttribute, //属性列表
  getCatList: getCatList, //获取购物车列表
  remove: remove, //购物车删除
  emptyCart: emptyCart, //清空购物车
  update: update, //更新购物车信息
  addOrder: addOrder, //购物车下单
  editUserInfo: editUserInfo, //完善/修改个人资料
  getUserInfo: getUserInfo, //获取个人资料
  changePwd: changePwd, //修改密码
  noticeList: noticeList, //获取消息列表
  doc: doc, //系统文章
  graffiti: graffiti, //商品涂鸦
  noticeInfo: noticeInfo, //消息详情
  ItemNewList: ItemNewList,
  orderItemPic: orderItemPic, // 订单商品涂鸦
  newItem: newItem,
  editPassword,
};
